module.exports = __webpack_public_path__ + "img/PORT10.eaee62ed.jpg";